import React from 'react';
import styled from 'styled-components';
import { ContentLoader } from '../../../../components/Loaders';
import { theme } from '../../../../styles/theme';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 16px;
`;
const Header = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 4px;
  height: 52px;
  @keyframes placeHolderShimmer {
    0% {
      background-position-x: -800px;
    }
    100% {
      background-position-x: 800px;
    }
  }
`;

const AnimatedBlock = styled.div`
  position: relative;
  animation-duration: 2s;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  animation-name: placeHolderShimmer;
  animation-timing-function: linear;
  background: linear-gradient(
    to right,
    ${theme.colors.level1} 8%,
    ${theme.colors.secondary300} 18%,
    ${theme.colors.level0} 33%,
    ${theme.colors.level1} 55%
  );
  background-size: 800px 104px;
`;

const DashboardInstanceLoader = () => {
  return (
    <Container>
      <Header>
        <AnimatedBlock style={{ width: '30%', height: '28px' }} />
        <AnimatedBlock style={{ width: '50%', height: '20px' }} />
      </Header>
      <ContentLoader noBorders={true} />
    </Container>
  );
};

export default DashboardInstanceLoader;
